var M = Object.defineProperty;
var S = (e, t, n) => t in e ? M(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var h = (e, t, n) => S(e, typeof t != "symbol" ? t + "" : t, n);
var v = /* @__PURE__ */ ((e) => (e.Electron = "electron", e.Web = "web", e))(v || {});
const f = {
  /**
   * Returns the Electron preload API (window.electronAPI) cast to T, or undefined if not in Electron.
   */
  getElectronApi: () => f.isElectron() ? (typeof globalThis.window < "u" ? globalThis.window : void 0)?.electronAPI : void 0,
  /**
   * Returns a friendly runtime type: AppRuntimeType.Electron or AppRuntimeType.Web.
   */
  getRuntime: () => f.isElectron() ? "electron" : "web",
  /**
   * Returns the OS-level color scheme preference ('dark' or 'light').
   * Falls back to 'light' when `window` or `matchMedia` is unavailable (eg: SSR).
   * TODO: Does this belong here?
   */
  getSystemThemePreference: () => typeof window > "u" ? "light" : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light",
  /**
   * Returns true when running inside an Electron renderer process.
   * Relies on the Electron preload script exposing window.electronAPI via contextBridge.
   * See: modules/electron/src/preload/PreloadWrapperAlpha.ts
   */
  isElectron: () => {
    try {
      const e = typeof globalThis.window < "u" ? globalThis.window : void 0;
      return !!(e && e.electronAPI);
    } catch {
      return !1;
    }
  },
  /** Returns true when running on Linux (neither macOS nor Windows). */
  isLinux: () => !f.isMacOS() && !f.isWindows(),
  /**
   * Returns true when running on macOS. Uses the modern `userAgentData` API
   * with a fallback to the deprecated `navigator.platform`.
   */
  isMacOS: () => l().startsWith("mac") || l() === "macos",
  /**
   * Returns true when running on Windows.
   */
  isWindows: () => l().startsWith("win")
}, l = () => typeof navigator > "u" ? "" : (navigator.userAgentData?.platform ?? navigator.platform ?? "").toLowerCase(), b = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i, g = {
  /**
   * Convert a hex color (3- or 6-digit, optional leading `#`) to OKLCH.
   * @param hex Hex color string.
   * @returns OKLCH triplet, or null when the input cannot be parsed.
   */
  hexToOklch(e) {
    const t = I(e);
    if (!t) return null;
    const [n, r, o] = [m(t[0]), m(t[1]), m(t[2])], s = x(n, r, o);
    return A(s);
  },
  /**
   * Test whether a string is a syntactically valid hex color (3- or 6-digit, optional `#`).
   * @param value Candidate string.
   * @returns True if parseable.
   */
  isValidHex(e) {
    return b.test(e.trim());
  },
  /**
   * Convert an OKLCH triplet to a 6-digit lowercase `#rrggbb` hex string.
   * Out-of-gamut colors are clamped to the sRGB cube; this is acceptable for the
   * theme studio's preview swatches where exact roundtrips are not required.
   * @param oklch OKLCH triplet.
   * @returns Hex string in `#rrggbb` form.
   */
  oklchToHex(e) {
    const t = N(e), [n, r, o] = k(t), s = p(n), i = p(r), a = p(o);
    return _([s, i, a]);
  }
}, I = (e) => {
  const t = e.trim(), n = b.exec(t);
  if (!n) return null;
  const r = n[1], o = r.length === 3 ? r.split("").map((d) => d + d).join("") : r, s = Number.parseInt(o.slice(0, 2), 16) / 255, i = Number.parseInt(o.slice(2, 4), 16) / 255, a = Number.parseInt(o.slice(4, 6), 16) / 255;
  return [s, i, a];
}, _ = (e) => {
  const t = (n) => {
    const r = Math.max(0, Math.min(1, n));
    return Math.round(r * 255).toString(16).padStart(2, "0");
  };
  return `#${t(e[0])}${t(e[1])}${t(e[2])}`;
}, m = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4), p = (e) => e <= 31308e-7 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - 0.055, x = (e, t, n) => {
  const r = 0.4122214708 * e + 0.5363325363 * t + 0.0514459929 * n, o = 0.2119034982 * e + 0.6806995451 * t + 0.1073969566 * n, s = 0.0883024619 * e + 0.2817188376 * t + 0.6299787005 * n, i = Math.cbrt(r), a = Math.cbrt(o), d = Math.cbrt(s);
  return {
    a: 1.9779984951 * i - 2.428592205 * a + 0.4505937099 * d,
    b: 0.0259040371 * i + 0.7827717662 * a - 0.808675766 * d,
    l: 0.2104542553 * i + 0.793617785 * a - 0.0040720468 * d
  };
}, k = (e) => {
  const t = e.l + 0.3963377774 * e.a + 0.2158037573 * e.b, n = e.l - 0.1055613458 * e.a - 0.0638541728 * e.b, r = e.l - 0.0894841775 * e.a - 1.291485548 * e.b, o = t * t * t, s = n * n * n, i = r * r * r;
  return [4.0767416621 * o - 3.3077115913 * s + 0.2309699292 * i, -1.2684380046 * o + 2.6097574011 * s - 0.3413193965 * i, -0.0041960863 * o - 0.7034186147 * s + 1.707614701 * i];
}, A = (e) => {
  const t = Math.sqrt(e.a * e.a + e.b * e.b);
  let n = Math.atan2(e.b, e.a) * 180 / Math.PI;
  return n < 0 && (n += 360), {
    c: t,
    h: n,
    l: e.l
  };
}, N = (e) => {
  const t = e.h * Math.PI / 180;
  return {
    a: e.c * Math.cos(t),
    b: e.c * Math.sin(t),
    l: e.l
  };
}, P = (e) => e.split("-").filter((t) => t.length > 0).map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(" "), H = {
  /**
   * Validate and normalize a theme declaration.
   * Pure: no side effects, no global state. Duplicate-name detection is the
   * Vite plugin's responsibility (Phase 4.1).
   * @param decl User-supplied declaration.
   * @returns Normalized declaration with `displayName` filled in.
   */
  defineTheme(e) {
    if (typeof e.name != "string" || e.name.length === 0) throw new Error("defineTheme: `name` is required");
    if (!g.isValidHex(e.brand)) throw new Error(`defineTheme: invalid brand hex "${e.brand}"`);
    if (!g.isValidHex(e.accent)) throw new Error(`defineTheme: invalid accent hex "${e.accent}"`);
    return {
      ...e,
      displayName: e.displayName ?? P(e.name)
    };
  }
}, B = H.defineTheme, O = "blufin-suspend-transitions", R = "*,*::before,*::after{transition:none!important;animation-duration:0s!important;animation-delay:0s!important;}", y = {
  /**
   * Runs `mutate` with transitions suspended. Forces a layout flush after the
   * mutation so the new styles apply with transitions still off, then removes
   * the suppression style on the next animation frame.
   * @param mutate Callback that performs the style/class mutation.
   */
  run(e) {
    if (typeof document > "u") {
      e();
      return;
    }
    const t = document.createElement("style");
    let n = !1;
    t.id = O, t.appendChild(document.createTextNode(R));
    try {
      document.head.appendChild(t), e(), document.documentElement.offsetHeight, requestAnimationFrame(() => {
        t.remove();
      }), n = !0;
    } finally {
      n || t.remove();
    }
  }
}, w = "data-theme", T = "data-mode", $ = {
  /** Reads the current resolved mode from `<html>`. Returns `null` if absent or invalid. */
  getMode() {
    if (typeof document > "u") return null;
    const e = document.documentElement.getAttribute(T);
    return e === "light" || e === "dark" ? e : null;
  },
  /** Reads the current theme name from `<html>`. Returns `null` if absent. */
  getTheme() {
    return typeof document > "u" ? null : document.documentElement.getAttribute(w);
  },
  /**
   * Writes `[data-mode]` on `<html>` inside a `SuspendTransitions.run`.
   * @param mode Resolved mode (callers must resolve `'system'` upstream).
   */
  setMode(e) {
    typeof document > "u" || y.run(() => {
      document.documentElement.setAttribute(T, e);
    });
  },
  /**
   * Writes `[data-theme]` on `<html>` inside a `SuspendTransitions.run`.
   * @param name Registered theme name.
   */
  setTheme(e) {
    typeof document > "u" || y.run(() => {
      document.documentElement.setAttribute(w, e);
    });
  }
}, c = {
  /**
   * Compares two epoch times.
   * Returns:
   *  -1 if epoch1 < epoch2
   *   0 if epoch1 == epoch2
   *   1 if epoch1 > epoch2
   * @param epoch1 - The first epoch time to compare.
   * @param epoch2 - The second epoch time to compare.
   */
  compareEpochs: (e, t) => {
    const n = c.convertEpochToMs(e), r = c.convertEpochToMs(t);
    return n < r ? -1 : n > r ? 1 : 0;
  },
  /**
   * Converts an epoch time in seconds to milliseconds.
   * @param epoch - The epoch time in seconds.
   */
  convertEpochToMs(e) {
    return e >= 1e12 ? e : e * 1e3;
  },
  /**
   * Converts an epoch time in milliseconds to seconds.
   * @param epoch - The epoch time in milliseconds.
   */
  convertEpochToSeconds(e) {
    return e < 1e12 ? e : Math.floor(e / 1e3);
  },
  /**
   * Calculates the difference between two epoch times in days.
   * @param epoch1 - The first epoch time.
   * @param epoch2 - The second epoch time.
   * @returns The absolute difference in days.
   */
  diffInDays(e, t) {
    return c.diffInHours(e, t) / 24;
  },
  /**
   * Calculates the difference between two epoch times in hours.
   * @param epoch1 - The first epoch time.
   * @param epoch2 - The second epoch time.
   * @returns The absolute difference in hours.
   */
  diffInHours(e, t) {
    return c.diffInMinutes(e, t) / 60;
  },
  /**
   * Calculates the difference between two epoch times in minutes.
   * @param epoch1 - The first epoch time.
   * @param epoch2 - The second epoch time.
   * @returns The absolute difference in minutes.
   */
  diffInMinutes(e, t) {
    return c.diffInSeconds(e, t) / 60;
  },
  /**
   * Calculates the difference between two epoch times in seconds.
   * @param epoch1 - The first epoch time.
   * @param epoch2 - The second epoch time.
   * @returns The absolute difference in seconds.
   */
  diffInSeconds(e, t) {
    const n = c.convertEpochToSeconds(e), r = c.convertEpochToSeconds(t);
    return Math.abs(n - r);
  }
}, u = class u {
  /**
   * Determines if the current page load was a result of a page refresh.
   * Uses the PerformanceNavigationTiming API when available, with a fallback to the deprecated PerformanceNavigation interface.
   */
  static isPageRefresh() {
    if (typeof window > "u" || typeof performance > "u") return !1;
    try {
      if (typeof performance.getEntriesByType == "function" && performance.getEntriesByType("navigation")?.[0]?.type === "reload")
        return !0;
      const t = performance.navigation;
      return t && typeof t.type == "number" ? t.type === 1 : !1;
    } catch {
      return !1;
    }
  }
  /**
   * Determines if this is the first page load in the current browser session.
   * Uses sessionStorage to track if the page has been loaded before in this session.
   */
  static isFirstPageLoadInSession() {
    if (typeof window > "u") return !0;
    try {
      return typeof sessionStorage > "u" || !sessionStorage ? !0 : sessionStorage.getItem(u.SESSION_KEY) ? !1 : (sessionStorage.setItem(u.SESSION_KEY, "true"), !0);
    } catch {
      return !0;
    }
  }
  /**
   * Gets the navigation context including whether the page load was a refresh,
   * whether it's the first load in the session, and the navigation type.
   */
  static getNavigationContext() {
    const t = u.isPageRefresh(), n = u.isFirstPageLoadInSession();
    let r = "unknown";
    if (typeof window > "u" || typeof performance > "u") return {
      isFirstPageLoadInSession: n,
      isPageRefresh: t,
      navigationType: r
    };
    try {
      if (typeof performance.getEntriesByType == "function") {
        const s = performance.getEntriesByType("navigation")?.[0]?.type;
        s && ["reload", "navigate", "back_forward", "prerender"].includes(s) && (r = s);
      }
      if (r === "unknown") {
        const o = performance.navigation;
        o && typeof o.type == "number" && (r = {
          0: "navigate",
          1: "reload",
          2: "back_forward"
        }[o.type] ?? "unknown");
      }
    } catch {
      r = "unknown";
    }
    return {
      isFirstPageLoadInSession: n,
      isPageRefresh: t,
      navigationType: r
    };
  }
};
h(u, "SESSION_KEY", "blufin_session_initialized");
let E = u;
export {
  f as A,
  c as E,
  E as N,
  y as S,
  $ as T,
  v as a,
  B as d
};
